import React from "react"
import { Input, Label } from "reactstrap"
import { layoutModeTypes } from "../../constants/layout"

const Switch = ({
  isChecked,
  onChange,
  onValue = "On",
  offValue = "Off",
  disabled = false,
  layoutMode,
  onClick,
}) => {
  const switchWidth = 50
  const switchContainer = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  }

  const sliderWrapper = {
    position: "relative",
    width: `${switchWidth}px`,
    height: "28px",
  }

  const sliderStyle = {
    position: "absolute",
    cursor: disabled ? "not-allowed" : "pointer",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: isChecked ? "rgba(0, 119, 139, 1)" : "#ccc",
    borderRadius: "34px",
    transition: ".4s",
  }

  const circleSize = 22
  const circleStyle = {
    position: "absolute",
    height: `${circleSize}px`,
    width: `${circleSize}px`,
    left: isChecked ? `${switchWidth - circleSize - 3}px` : "3px",
    bottom: "3px",
    backgroundColor: "white",
    borderRadius: "50%",
    transition: ".4s",
  }

  return (
    <div style={switchContainer}>
      <span
        style={{
          fontSize: "14px",
          color:
            layoutMode === layoutModeTypes.LIGHT
              ? "rgba(126, 132, 146, 1)"
              : "#fff",
          paddingBottom: "10px",
        }}
      >
        {isChecked ? onValue : offValue}
      </span>
      <Label style={sliderWrapper}>
        <Input
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          onClick={onClick}
          disabled={disabled}
          style={{ display: "none" }}
        />
        <div style={sliderStyle}>
          <div style={circleStyle} />
        </div>
      </Label>
    </div>
  )
}

export default Switch
